module.exports = __webpack_public_path__ + "img/401.43829e37.png";